import React, { FC } from 'react';
import styled from 'styled-components';
import AdminWatermark from '../modules/admin-watermark/admin-watermark';
import V2Link from '../modules/v2-link/v2-link';
import AdminAccessRegion from '../modules/admin-access/admin-access-region';

const AdminDashboardTab: FC = () => {
    return (
        <DashboardGrid>
            <AdminWatermark />
            <V2Link />
            <AdminAccessRegion />
        </DashboardGrid>
    );
};

const DashboardGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export default AdminDashboardTab;
